var path = 'areas/projects/action-template-fields/field-MultiLineText.html';
var html = "<div> <textarea ng-model=vm.value class=form-control rows=6 placeholder={{vm.placeholder}}></textarea> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/action-template-fields/field-MultiLineText.html
// module id = 2958193437046340
// module chunks = 1